import React, { Component } from 'react';
import ChipInput from 'material-ui-chip-input';
import { connect } from 'react-redux';
import localforage from 'localforage';
import Cookies from 'universal-cookie';
import { menuSetting } from '../actions/index';
import { fetch_taglist } from '../actions/fetch_taglist';
import { fetch_catlist } from '../actions/fetch_catlist';
import { bindActionCreators } from 'redux';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import {
  Table,
  TableBody,
  TableFooter,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import Checkbox from 'material-ui/Checkbox';
import FontIcon from 'material-ui/FontIcon';
import $ from 'jquery';
import LoadingBoxes from '../components/loadingBoxes';
import LoadingText from '../components/loadingText';
import { checkSexOption } from '../utility/tool';

let cookies = new Cookies();

const text_field_style = {
  width: 500
}
const chipinput_style = {
  width: '74%'
}
const radioBtnStyle = {
  cat_op: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    width: 50,
    margin: '0 auto',
    fontSize: 16,
    fontWeight: 500
  },
  radioButton: {
    marginBottom: 16,
  },
  inputStyle: {
    marginRight: 5,
    color: '#f48500',
    fill: '#f48500'
  },
}

const tableStyle = {
  tableHeaderBorder: {
    borderBottom: '1px solid #f48500',
  },
  tableSelectAllIcon: {
    marginRight: 5,
  },
  tableSelectAllLabel: {
    fontSize: 13,
    color: '#f48500',
    fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"',
  },
}

const sexOptions = [
  { value: 0, name: '男' },
  { value: 1, name: '女' },
  { value: 2, name: '其他' },
]

class Kol_chipinput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chipsData: props.Pchips,
      cateChipsData: props.PcateChips,
      period: props.Pperiod,
      fansMax: props.PfansMax,
      fansMin: props.PfansMin,
      dayQuery: props.PdayQuery,
      sex: props.Psex,
      sourceOption: props.PsourceOption,
      sourceValue: props.PsourceValue,
      kol_name: props.Pkol_name,
      cat_op: props.Pcat_op,
      errorText: '',
      sourceErrorText: '',
      open: false,
      autoFuck: ''
    }
  }

  handleFansChange(event, value) {
    let targetName = event.target.name

    this.setState({ [event.target.name]: event.target.value })

    // 當user在調整fansMin的時候 也同時想調整fansMax 或反過來
    if (event.target.name === 'fansMin') {
      this.refs['fansMaxRef'].makeValid()
    } else {
      this.refs['fansMinRef'].makeValid()
    }

  }

  handlePeriodChange(event, index, value) {
    this.setState({
      period: value
    });
    var days = 0;
    switch (value) {
      case 1:
        days = 30;
        break;
      case 2:
        days = 90;
        break;
      case 3:
        days = 180;
        break;
      case 4:
        days = 365;
        break;
    }
    this.setState({ dayQuery: days });
  }

  handleSelectChange(event, index, payload) {
    payload.sort((a, b) => { return a - b })
    this.setState({ sex: payload });
  }

  handleSourceChange(className, value) {
    const { sourceOption } = this.state

    if (sourceOption[className] === value) {
      sourceOption[className] = ''
    } else {
      sourceOption[className] = value
    }

    this.setState({ sourceOption })

  }

  searchBtn = () => {
    let submitSourceValue = this.checkSourceValue()
    let newCatlist = this.reconstructCatlist()

    if (submitSourceValue.length === 0) {
      this.setState({ sourceErrorText: '必塡欄位' })
      return
    }
    this.setState({
      errorText: '',
      sourceErrorText: ''
    })
    this.props.triggerParentUpdate(
      this.state.chipsData,
      this.state.cateChipsData,
      this.state.fansMin,
      this.state.fansMax,
      this.state.dayQuery,
      this.state.period,
      this.state.sex,
      this.state.sourceOption,
      submitSourceValue,
      this.state.kol_name,
      this.state.cat_op,
      newCatlist
    );
  }

  resetQueryInfo() {
    let newCatlist = this.reconstructCatlist()

    this.props.triggerParentUpdate([], [], 0.1, 3000, 30, 1, [0, 1, 2], { fbClass: "FB", ytClass: "YT", igClass: "IG" }, 'FB,YT,IG', '', 'or', newCatlist)
  }

  checkSourceValue() {
    const { sourceOption } = this.state
    let mapSourceResult = []

    Object.keys(sourceOption).forEach((item, index) => {
      if (sourceOption[item] !== '') {
        mapSourceResult.push(sourceOption[item]);
      }
    })

    return mapSourceResult.join(',')
  }

  reconstructCatlist() {

    let obj = {}
    this.props.catlist.data.forEach((item, index) => {
      item.data.forEach((item2, index2) => {
        item2.data.forEach((item3, index3) => {
          obj[item3] = item.group
        })
      })
    })

    return obj

  }

  onUpdateInput(fuck) {
    let fucktrim = fuck.trim();
    this.setState({ autoFuck: fucktrim });
  }

  fuckonBlur(fuck) {
    if (this.state.autoFuck !== '' && !this.state.chipsData.includes(this.state.autoFuck)) {
      this.addChips(this.state.autoFuck);
    }
  }

  chipsApply(chips) {
    this.setState({ chipsData: chips });
    if (chips.toString() != '') {
      this.setState({ errorText: '' });
    }
  }

  addChips(chips) {
    this.setState({ autoFuck: '' });
    if (this.state.chipsData.length < 5) {
      var array = this.state.chipsData;
      array.push(chips);
      this.setState({ chipsData: array });
    }
  }

  deleteChips(deletedChip) {
    var array = this.state.chipsData;
    var index = array.indexOf(deletedChip);
    if (index > -1) {
      array.splice(index, 1);
    }
    this.setState({ chipsData: array });
  }

  cateChipsApply(chips) {
    this.setState({ cateChipsData: chips });
  }

  cateAddChips(chips) {
    var cateArray = this.state.cateChipsData;
    cateArray.push(chips);
    this.setState({ cateChipsData: cateArray });
  }

  cateDeleteChips(deletedChip) {
    var cateArray = this.state.cateChipsData;
    var index = cateArray.indexOf(deletedChip);
    if (index > -1) {
      cateArray.splice(index, 1);
    }
    this.setState({ cateChipsData: cateArray });
  }

  sexMenuItems(sexOptions) {
    return sexOptions.map((sexOption) => (
      <MenuItem
        key={sexOption.value}
        insetChildren={true}
        checked={typeof this.state.sex === 'undefined' ? false : this.state.sex.includes(sexOption.value)}
        value={sexOption.value}
        primaryText={sexOption.name}
      />
    ))
  }

  fieldTable(catlistData) {
    const fieldTableWidth = 56;
    const titleTableWidth = 35;
    const operatorWrapWidth = 9;

    return (
      <div>
        <p className='modalTitle'>新增屬性</p>
        <div className="tableContent">
          <div className='fieldTable' style={{ width: `${fieldTableWidth}%` }}>
            {this.loopGroup('skill', catlistData[0])}
          </div>
          <div className='operatorWrap' style={{ width: `${operatorWrapWidth}%` }}>
            <RadioButtonGroup
              name="cat_op"
              className="cat_op"
              defaultSelected="or"
              style={radioBtnStyle.cat_op}
              valueSelected={this.state.cat_op}
              onChange={(event, value) => this.handleFansChange(event, value)}
            >
              <RadioButton
                value="or"
                label="或"
                style={radioBtnStyle.radioButton}
                iconStyle={radioBtnStyle.inputStyle}
              />
              <RadioButton
                value="and"
                label="且"
                style={radioBtnStyle.radioButton}
                iconStyle={radioBtnStyle.inputStyle}
              />
            </RadioButtonGroup>
          </div>
          <div className='titleTable' style={{ width: `${titleTableWidth}%` }}>
            {this.loopGroup('job', catlistData[1])}
          </div>
        </div>
      </div>
    )
  }

  loopGroup(type, groupData) {
    const fieldColumnWidth = Math.floor(100 / (groupData.data.length))
    const tableKey = new Date().getTime()

    let column = groupData.data.map((el, idx) => {
      return (
        <div key={idx} className='tableDiv' style={{ width: `${fieldColumnWidth}%` }}>
          <Checkbox
            name={`taleDiv-${idx}`}
            label="全部"
            checked={this.checkAllIsTrue(el.data)}
            onCheck={event => this.tableSelectAll(event, el.data)}
            style={tableStyle.tableHeaderBorder}
            iconStyle={tableStyle.tableSelectAllIcon}
            labelStyle={tableStyle.tableSelectAllLabel}
          />
          <Table
            key={tableKey}
            multiSelectable={true}
            onRowSelection={aaa => this.onRowSelection(aaa, el.data, type)}
          >
            <TableBody
              deselectOnClickaway={false}
            >
              {this.innerTable(el)}
            </TableBody>
          </Table>
        </div>
      )
    })

    return (
      <div>
        <div className='sectionTitleStyle'>{groupData.group}</div>
        {column}
      </div>
    )
  }

  innerTable(columnData) {
    return (
      columnData.data.map((el, idx) => {
        let isSelected = this.state.cateChipsData.indexOf(el) > -1 ? true : false;
        return (
          <TableRow key={el} className='fieldTableTR' selected={isSelected}>
            <TableRowColumn className='fieldTableTD'>{el}</TableRowColumn>
          </TableRow>
        )
      })
    )
  }

  componentWillMount() {
    if (this.state.chipsData.length === 0) {
    }

  }

  componentDidMount() {
    // custom validation rule
    ValidatorForm.addValidationRule('cMinfloat', (value) => {
      if (parseFloat(value) >= 0.05) {
        return true
      }
      return false
    })

    ValidatorForm.addValidationRule('cFanNum', (value) => {
      if (Number(this.state.fansMax) > Number(this.state.fansMin)) {
        return true
      }
      return false
    })

    localforage.getItem('dashQueryValue').then((value) => {
      if (value) {
        this.setState({
          chipsData: value.chipsData,
          cateChipsData: value.cateChipsData,
          period: value.period,
          fansMax: value.fansMax,
          fansMin: value.fansMin,
          dayQuery: value.dayQuery,
          sex: value.sex,
          sourceOption: value.sourceOption,
          sourceValue: value.sourceValue,
          kol_name: value.kol_name,
          cat_op: value.cat_op,
        })
      }
    }).catch((err) => {
      console.log("err", err);
    })

    this.props.fetch_catlist(cookies.get('token'))
  }

  componentDidUpdate(prev) {
    // if (prev.queryInfo.q !== this.props.queryInfo.q){
    //     this.props.menuSetting(this.props.queryInfo.q)
    // }
  }

  handleOpen = () => {
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  checkAllIsTrue = (data) => {
    let cateArray = this.state.cateChipsData
    let filterArr = cateArray.filter(function (item) {
      return data.indexOf(item) > -1
    })

    return filterArr.length === data.length
  }

  tableSelectAll(event, columnData) {
    let cateArray = this.state.cateChipsData

    // step one: delete all column data (categories)
    cateArray = cateArray.filter((item) => {
      return columnData.indexOf(item) < 0
    })

    // step two: add all column data (categories)
    if (event.target.checked) {
      cateArray = cateArray.concat(columnData)
    }

    this.setState({ cateChipsData: cateArray })
  }

  onRowSelection = (selectedRow, el, type) => {
    let cateArray = this.state.cateChipsData

    // step one: delete all column data (categories)
    cateArray = cateArray.filter((item) => {
      return el.indexOf(item) < 0
    })

    // step two: add column data (categories)
    selectedRow.map((item) => {
      cateArray.push(el[item])
    })

    this.setState({ cateChipsData: cateArray })
  }

  render() {
    const { taglist, taglist_isloading, taglist_error, catlist, catlist_isloading, catlist_error, login } = this.props
    const { sourceOption, sourceErrorText } = this.state

    if (catlist_isloading) {
      return (
        <div>
          <LoadingBoxes />
          <LoadingText />
        </div>
      )
    }

    const color = this.props.bgSetting === 'dark' ? '#fff' : '#333333';
    const bgColor = this.props.bgSetting === 'dark' ? '#383838' : '#EAE8E3';
    const label_style = this.props.bgSetting === 'dark' ?
      { marginTop: 30, top: 12, left: 0, color: '#fff', fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"' } :
      { marginTop: 30, top: 12, left: 0, color: '#000', fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"' };
    const focusStyle = this.props.bgSetting === 'dark' ?
      { marginTop: 10, top: 12, left: 0, color: '#fff', fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"' } :
      { marginTop: 10, top: 12, left: 0, color: '#100100100', fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"' };
    const font_style = { fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"' };
    const actions = [
      <FlatButton
        label="新增"
        primary={true}
        onClick={this.handleClose}
      />
    ];

    const searchBtnStyle = { verticalAlign: 'top', width: '47%', height: 50 }
    const searchBtnLabel = { verticalAlign: 'middle', paddingLeft: '3px', fontSize: '14px' }
    const inputError = {
      position: 'absolute',
      left: '0',
      bottom: '-20px'
    }
    const showSourceErrorText = sourceErrorText.length === 0 ? '' : 'showError'
    const numberValidatorStyle = { width: '73px', fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"' }
    const periodValidatorStyle = { width: '130px', fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"' }
    const kolNameValidatorStyle = { width: '195px', fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"' }

    let cateDataSource = [];
    catlist.data.map((item) => {
      cateDataSource = cateDataSource.concat(item);
    })

    return (
      <div style={{ textAlign: 'left' }}>
        <ValidatorForm
          ref={r => (this.form = r)}
          onSubmit={this.searchBtn.bind(this)}
        >
          <div className="catChipinputWrapper">
            <ChipInput
              //ref="chipinput"
              //defaultValue={this.state.cateChipsData}
              //onUpdateInput={this.onUpdateInput}
              //dataSourceConfig={{text:'fans',value:'fid'}}
              onRequestAdd={(chips) => this.cateAddChips(chips)}
              onRequestDelete={(deletedChip) => this.cateDeleteChips(deletedChip)}
              // dataSource={catlist.data}
              dataSource={cateDataSource}
              textFieldStyle={text_field_style}
              style={chipinput_style}
              className='chipinput cat'
              errorText=""
              floatingLabelStyle={label_style}
              floatingLabelFocusStyle={focusStyle}
              floatingLabelText="請選擇屬性（非必填）："
              newChipKeyCodes={[]}
              menuProps={{ menuItemStyle: { color: color, width: '500px' } }}
              menuStyle={{ background: bgColor, width: '500px' }}
              value={this.state.cateChipsData}
              underlineStyle={{ borderColor: '#cacaca', borderWidth: '1px' }}
              maxSearchResults={10}
              underlineFocusStyle={{ borderColor: '#ed9600', borderWidth: '2px' }}
            //onChange={(chips) => this.cateChipsApply(chips)}
            />
            <div className='openSidebarBtn' onClick={this.handleOpen}><div className='plusSidebarBtn'>+</div>新增屬性</div>
          </div>
          <Dialog
            // title={titles}
            actions={actions}
            contentClassName="modalContentWrapper"
            bodyClassName="modalContentBody"
            actionsContainerClassName="modalContentAction"
            modal={false}
            open={this.state.open}
            autoScrollBodyContent={true}
            onRequestClose={this.handleClose}
            className="dialogBtn"
          >
            {this.fieldTable(catlist.data)}
          </Dialog>
          <div className="kol_select_main">
            <ChipInput
              //ref="chipinput"
              //defaultValue={this.state.chipsData}
              onUpdateInput={(fuckyes) => this.onUpdateInput(fuckyes)}
              //dataSourceConfig={{text:'fans',value:'fid'}}
              onRequestAdd={(chips) => this.addChips(chips)}
              onRequestDelete={(deletedChip) => this.deleteChips(deletedChip)}
              //dataSource={taglist.data}
              textFieldStyle={text_field_style}
              style={chipinput_style}
              className='chipinput key'
              errorText={this.state.errorText}
              floatingLabelStyle={label_style}
              floatingLabelFocusStyle={focusStyle}
              floatingLabelText="請輸入貼文關鍵字（非必填，最多5個）："
              //newChipKeyCodes = {[]}
              menuProps={{ menuItemStyle: { color: color, width: '500px' } }}
              menuStyle={{ background: bgColor, width: '500px' }}
              value={this.state.chipsData}
              underlineStyle={{ borderColor: '#cacaca', borderWidth: '1px' }}
              maxSearchResults={10}
              underlineFocusStyle={{ borderColor: '#ed9600', borderWidth: '2px' }}
              //onChange={(chips) => this.chipsApply(chips)}
              onBlur={(fuck) => this.fuckonBlur(fuck)}
            />
            <div className={`kol_select_source ${showSourceErrorText}`}>
              <p>請點選平台 :</p>
              <div className="sourceIconWrapper">
                <div
                  className={`sourceIcon fb_inactive ${sourceOption.fbClass}`}
                  onClick={() => this.handleSourceChange('fbClass', 'FB')}
                ></div>
                <div
                  className={`sourceIcon yt_inactive ${sourceOption.ytClass}`}
                  onClick={() => this.handleSourceChange('ytClass', 'YT')}
                ></div>
                <div
                  className={`sourceIcon ig_inactive ${sourceOption.igClass}`}
                  onClick={() => this.handleSourceChange('igClass', 'IG')}
                ></div>
                <span className="sourceErrorText">{this.state.sourceErrorText}</span>
              </div>
            </div>
          </div>
          <div className="kol_select_main">
            <div className="rangeAndPeriod">
              <div className="kol_select">
                <p>粉絲人數區間(以萬為單位)：</p>
                <TextValidator
                  ref="fansMinRef"
                  onChange={(event, value) => this.handleFansChange(event, value)}
                  name="fansMin"
                  value={this.state.fansMin}
                  className="fanNumValidator"
                  validators={['required', 'isPositive', 'cMinfloat', 'maxNumber:3000', 'cFanNum']}
                  errorMessages={['必塡欄位', '請填寫數字', '最少 0.05', '至多3000萬', '須小於最大值']}
                  errorStyle={inputError}
                  style={numberValidatorStyle}
                  underlineFocusStyle={{ borderColor: '#ed9600' }}
                />
                <p className="kol_select_symbol">萬 ~</p>
                <TextValidator
                  ref="fansMaxRef"
                  onChange={(event, value) => this.handleFansChange(event, value)}
                  name="fansMax"
                  value={this.state.fansMax}
                  className="fanNumValidator"
                  validators={['required', 'isPositive', 'cMinfloat', 'maxNumber:3000', 'cFanNum']}
                  errorMessages={['必塡欄位', '請填寫數字', '最少 0.05', '至多3000萬', '須大於最小值']}
                  errorStyle={inputError}
                  style={numberValidatorStyle}
                  underlineFocusStyle={{ borderColor: '#ed9600' }}
                />
                <p className="kol_select_symbol">萬之間</p>
              </div>
              <div className="kol_select">
                <p>查詢時間：</p>
                <SelectField
                  value={this.state.period}
                  onChange={(event, index, value) => this.handlePeriodChange(event, index, value)}
                  style={periodValidatorStyle}
                  underlineFocusStyle={{ borderColor: '#ed9600' }}
                  className="ddpBtn"
                >
                  <MenuItem style={font_style} value={1} primaryText="一個月內" />
                  <MenuItem style={font_style} value={2} primaryText="三個月內" />
                  <MenuItem style={font_style} value={3} primaryText="六個月內" />
                  {/*<MenuItem style = {font_style} value={4} primaryText="一年內" />*/}
                </SelectField>
              </div>
              <div className="kol_select">
                <p>性別：</p>
                <SelectValidator
                  multiple={true}
                  name="sex"
                  onChange={(event, index, payload) => this.handleSelectChange(event, index, payload)}
                  value={this.state.sex}
                  className="ddpBtn"
                  style={periodValidatorStyle}
                  underlineFocusStyle={{ borderColor: '#ed9600' }}
                >
                  {this.sexMenuItems(sexOptions)}
                </SelectValidator>
              </div>
            </div>
            <div className="kol_select kol_name">
              <p>查詢粉專：</p>
              <TextValidator
                onChange={(event, value) => this.handleFansChange(event, value)}
                name="kol_name"
                value={this.state.kol_name}
                className="fanNameValidator"
                style={kolNameValidatorStyle}
                underlineFocusStyle={{ borderColor: '#ed9600' }}
              />
            </div>
            <div className="searchWrapper">
              <div className="resetQueryInfo" onClick={() => this.resetQueryInfo()}>回復預設值</div>
              <RaisedButton
                className="searchBtn"
                label="搜尋"
                type="submit"
                backgroundColor="transparent"
                style={searchBtnStyle}
                buttonStyle={font_style}
                labelStyle={searchBtnLabel}
                labelColor="#fff"
                icon={<FontIcon className="material-icons" color='#fff' style={{ marginTop: '5px' }}>search</FontIcon>}
              />
            </div>
          </div>
        </ValidatorForm>
      </div>
    )
  }
}

function mapStateToProps({ bgSetting, taglist, taglist_isloading, taglist_error, catlist, catlist_isloading, catlist_error, login }) {
  return { bgSetting, taglist, taglist_isloading, taglist_error, catlist, catlist_isloading, catlist_error, login };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ menuSetting, fetch_taglist, fetch_catlist }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Kol_chipinput);



// WEBPACK FOOTER //
// ./src/containers/kol_chipinput.js